module.exports = __webpack_public_path__ + "wxMicroService/img/eightCar.3322ff95.gif";